// import React, { useState, useRef, useEffect } from "react";
// import { ChevronDown, Pencil, Trash2 } from "lucide-react";
// import VideoModal from "./VideoModal";
// import GalleryModal from "./GalleryModal";
// import { useVideo } from "../context/VideoContext";
// import { useGallery } from "../context/GalleryContext"
// import toast from "react-hot-toast";

// const GalleryManagement = () => {
//   const [videoOpen, setVideoOpen] = useState(false);
//   const [galleryOpen, setGalleryOpen] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [viewType, setViewType] = useState("gallery");
//   const [editData, setEditData] = useState(null);

//   // 🔥 NEW (delete modal state)
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [deleteType, setDeleteType] = useState("");

//   const dropdownRef = useRef(null);

//   const { videos, deleteVideo } = useVideo();
//   const { images, deleteImage } = useGallery();

//   const openEditGallery = (img) => {
//     setEditData(img);
//     setGalleryOpen(true);
//   };

//   const openEditVideo = (video) => {
//     setEditData(video);
//     setVideoOpen(true);
//   };

//   //  confirm delete
  
//   const confirmDelete = () => {
//   if (deleteType === "gallery") {
//     deleteImage(deleteItem.id);
//     toast.success("Gallery deleted successfully ✅");
//   } else {
//     deleteVideo(deleteItem.id);
//     toast.success("Video deleted successfully ✅");
//   }

//   setDeleteItem(null);
//   setDeleteType("");
// };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target)
//       ) {
//         setDropdownOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <div className="min-h-screen">

//       {/* Header */}
//       <div className="flex flex-wrap justify-between items-center mb-6 gap-3">
//         <h1 className="text-2xl md:text-3xl font-serif text-gray-800">
//           Gallery Management
//         </h1>

//         <div className="flex items-center gap-3 flex-wrap">
          
//           {/* Dropdown */}
//           <div className="relative w-full sm:w-auto" ref={dropdownRef}>
//             <button
//               onClick={() => setDropdownOpen(!dropdownOpen)}
//               className="flex items-center justify-between gap-2 bg-white border px-4 py-2 rounded-md shadow-sm text-sm w-full sm:w-auto"
//             >
//               {viewType === "gallery" ? "Gallery List" : "Video List"}
//               <ChevronDown size={16} />
//             </button>

//             {dropdownOpen && (
//               <div className="
//                 absolute mt-2 bg-white border rounded-md shadow-lg z-50
//                 w-full left-0
//                 sm:w-40 sm:right-0 sm:left-auto
//               ">
//                 <button
//                   onClick={() => {
//                     setViewType("gallery");
//                     setDropdownOpen(false);
//                   }}
//                   className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
//                 >
//                   Gallery List
//                 </button>

//                 <button
//                   onClick={() => {
//                     setViewType("video");
//                     setDropdownOpen(false);
//                   }}
//                   className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
//                 >
//                   Video List
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Buttons */}
//           <button
//             onClick={() => {
//               setEditData(null);
//               setVideoOpen(true);
//             }}
//             className="bg-[#45A301] text-white px-4 py-2 rounded-md text-sm"
//           >
//             + Add Video
//           </button>

//           <button
//             onClick={() => {
//               setEditData(null);
//               setGalleryOpen(true);
//             }}
//             className="bg-[#45A301] text-white px-4 py-2 rounded-md text-sm"
//           >
//             + Add Gallery
//           </button>
//         </div>
//       </div>

//       {/* TABLE */}
//       <div className="bg-white rounded-xl border overflow-hidden">
        
//         <div className="overflow-x-auto no-scrollbar">

//           {/* Header */}
//           <div className="min-w-[700px] grid grid-cols-5 px-6 py-4 bg-gray-50 text-sm font-medium">
//             <div>Preview</div>
//             <div>Title</div>
//             <div>Type</div>
//             <div>Info</div>
//             <div className="text-right">Actions</div>
//           </div>

//           {/* Gallery */}
//           {viewType === "gallery" &&
//             images.map((img) => (
//               <div
//                 key={img.id}
//                 className="min-w-[700px] grid grid-cols-5 items-center px-6 py-5 border-t"
//               >
//                 <img
//                   src={img.image}
//                   alt={img.title}
//                   className="w-24 h-14 rounded-md object-cover"
//                 />

//                 <div className="truncate">{img.title}</div>

//                 <div>
//                   <span className="text-xs bg-blue-100 text-blue-700 px-3 py-1 rounded-full">
//                     Gallery
//                   </span>
//                 </div>

//                 <div className="text-sm text-gray-500 truncate">
//                   {img.tag}
//                 </div>

//                 <div className="flex justify-end gap-4">
//                   <Pencil
//                     size={18}
//                     className="cursor-pointer hover:text-blue-600"
//                     onClick={() => openEditGallery(img)}
//                   />

//                   {/* 🔥 UPDATED DELETE */}
//                   <Trash2
//                     size={18}
//                     className="cursor-pointer text-red-500"
//                     onClick={() => {
//                       setDeleteItem(img);
//                       setDeleteType("gallery");
//                     }}
//                   />
//                 </div>
//               </div>
//             ))}

//           {/* Video */}
//           {viewType === "video" &&
//             videos.map((video) => (
//               <div
//                 key={video.id}
//                 className="min-w-[700px] grid grid-cols-5 items-center px-6 py-5 border-t"
//               >
//                 <img
//                   src={video.thumbnail}
//                   alt={video.title}
//                   className="w-24 h-14 rounded-md object-cover"
//                 />

//                 <div className="truncate">{video.title}</div>

//                 <div>
//                   <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full">
//                     Video
//                   </span>
//                 </div>

//                 <div className="text-sm text-gray-500 truncate">
//                   {video.sectionTitle}
//                 </div>

//                 <div className="flex justify-end gap-4">
//                   <Pencil
//                     size={18}
//                     className="cursor-pointer hover:text-blue-600"
//                     onClick={() => openEditVideo(video)}
//                   />

//                   {/* 🔥 UPDATED DELETE */}
//                   <Trash2
//                     size={18}
//                     className="cursor-pointer text-red-500"
//                     onClick={() => {
//                       setDeleteItem(video);
//                       setDeleteType("video");
//                     }}
//                   />
//                 </div>
//               </div>
//             ))}

//         </div>

//         {/* Empty */}
//         {viewType === "gallery" && images.length === 0 && (
//           <div className="p-6 text-center text-gray-500">
//             No gallery images available.
//           </div>
//         )}

//         {viewType === "video" && videos.length === 0 && (
//           <div className="p-6 text-center text-gray-500">
//             No videos available.
//           </div>
//         )}
//       </div>

//       {/* 🔥 DELETE CONFIRM MODAL */}
//       {deleteItem && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg">
//             <h2 className="text-lg font-semibold mb-2">
//               Confirm Delete
//             </h2>

//             <p className="text-sm text-gray-500 mb-6">
//               Are you sure you want to delete this item?
//             </p>

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setDeleteItem(null)}
//                 className="px-4 py-2 border rounded-md text-sm"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={confirmDelete}
//                 className="px-4 py-2 bg-green-300 text-white rounded-md text-sm"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modals */}
//       {videoOpen && (
//         <VideoModal close={() => setVideoOpen(false)} editData={editData} />
//       )}

//       {galleryOpen && (
//         <GalleryModal close={() => setGalleryOpen(false)} editData={editData} />
//       )}
//     </div>
//   );
// };

// export default GalleryManagement;




import { useState, useRef, useEffect, useMemo } from "react";
import { FiMoreHorizontal, FiEdit, FiTrash2, FiDownload, FiPlus } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import * as XLSX from "xlsx";
import PageLoader from "../helpers/PageLoader";
import VideoModal from "./VideoModal";
import GalleryModal from "./GalleryModal";

const GalleryManagement = () => {
  const [loading, setLoading] = useState(false);
  const [media, setMedia] = useState([]);
  const [search, setSearch] = useState("");
  const [viewType, setViewType] = useState("All Media"); // Filter
  
  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [deleteItem, setDeleteItem] = useState(null);
  
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [galleryModalOpen, setGalleryModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const btnRefs = useRef({});
  const menuRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const fetchMedia = async () => {
    try {
      setLoading(true);
      const res = await api({
        url: SummaryApi.getAllGallery.url,
        method: SummaryApi.getAllGallery.method,
      });
      setMedia(res.data?.data || []);
    } catch (err) {
      toast.error("Failed to fetch media");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedia();
  }, []);

  const filteredData = useMemo(() => {
    let data = media;
    if (viewType !== "All Media") {
      const typeKey = viewType === "Gallery" ? "IMAGE" : "VIDEO";
      data = data.filter((item) => item.type === typeKey);
    }
    if (search) {
      const term = search.toLowerCase();
      data = data.filter(
        (item) =>
          item.title?.toLowerCase().includes(term) ||
          item.tag?.toLowerCase().includes(term) ||
          item.section?.toLowerCase().includes(term)
      );
    }
    return data;
  }, [media, search, viewType]);

  const currentData = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(start, start + itemsPerPage);
  }, [filteredData, currentPage]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => ({
      Title: `${item.title || ""}`,
      Type: `${item.type}`,
      Tag: `${item.tag || "-"}`,
      Section: `${item.section}`,
      URL: `${item.type === "IMAGE" ? item.image?.url : item.videoUrl}`,
      "Created At": `${new Date(item.createdAt).toLocaleDateString()}`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const colWidths = Object.keys(excelData[0] || {}).map((key) => ({
      wch: Math.max(key.length, 20),
    }));
    worksheet["!cols"] = colWidths;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Media");
    XLSX.writeFile(workbook, "Gallery_Media_List.xlsx");
  };

  const handleToggle = (id) => {
    if (openMenuId === id) return setOpenMenuId(null);
    const rect = btnRefs.current[id].getBoundingClientRect();
    const dropdownHeight = 110;
    setMenuPosition({
      top: window.innerHeight - rect.bottom < dropdownHeight ? rect.top - dropdownHeight : rect.bottom + 5,
      left: rect.left - 120,
    });
    setOpenMenuId(id);
  };

  const handleDelete = async () => {
    try {
      await api({
        url: SummaryApi.deleteOneGallery.url(deleteItem._id),
        method: SummaryApi.deleteOneGallery.method,
      });
      toast.success("Deleted successfully");
      setMedia((prev) => prev.filter((m) => m._id !== deleteItem._id));
      setDeleteItem(null);
    } catch (err) {
      toast.error("Delete failed");
    }
  };

  useEffect(() => {
    const closeMenu = () => setOpenMenuId(null);
    window.addEventListener("scroll", closeMenu, true);
    return () => window.removeEventListener("scroll", closeMenu, true);
  }, []);

  if (loading) return <PageLoader />;

  return (
    <div>
      <ToastContainer position="top-center" autoClose={2000} />
      
      <div className="flex justify-between items-center mb-2">
        <h1 className="text-2xl pb-4 md:text-3xl font-serif text-gray-800">Gallery Management</h1>
        <div className="flex gap-2 mb-4">
          <button onClick={() => { setEditData(null); setVideoModalOpen(true); }} className="bg-[#45A301] text-white px-4 py-2 rounded-md text-sm flex items-center gap-2">
            <FiPlus /> Add Video
          </button>
          <button onClick={() => { setEditData(null); setGalleryModalOpen(true); }} className="bg-[#45A301] text-white px-4 py-2 rounded-md text-sm flex items-center gap-2">
            <FiPlus /> Add Image
          </button>
          <button onClick={exportToExcel} className="bg-white border px-4 py-2 rounded-md text-sm flex items-center gap-2">
            <FiDownload /> Export
          </button>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
        <input
          type="text"
          placeholder="Search media..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border rounded-md px-4 py-2 text-sm w-full lg:w-80 outline-none focus:ring-2 ring-gray-200"
        />
        <div className="flex items-center gap-3">
          <select value={viewType} onChange={(e) => setViewType(e.target.value)} className="border rounded-md px-4 py-2 text-sm outline-none">
            <option>All Media</option>
            <option>Gallery</option>
            <option>Video</option>
          </select>
          <div className="text-sm text-gray-500">Showing {filteredData.length} entries</div>
        </div>
      </div>

      <div className="overflow-x-auto border rounded-lg bg-white">
        <div className="min-w-[800px]">
          <div className="grid grid-cols-5 bg-gray-100 px-6 py-4 text-sm font-semibold text-gray-700">
            <div>Preview</div>
            <div>Title</div>
            <div>Type</div>
            <div>Tag / Section</div>
            <div className="text-center">Actions</div>
          </div>

          {currentData.length === 0 ? (
            <div className="px-6 py-10 text-center text-gray-500">No media items found</div>
          ) : (
            currentData.map((item) => (
              <div key={item._id} className="grid grid-cols-5 items-center px-6 py-4 text-sm border-t hover:bg-[#F7F9F4] transition-colors">
                <div className="w-20 h-12 rounded overflow-hidden bg-gray-200">
                  <img src={item.type === "IMAGE" ? item.image?.url : item.thumbnail?.url} className="w-full h-full object-cover" alt="prev" />
                </div>
                <div className="font-medium truncate pr-4">{item.title}</div>
                <div>
                  <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase ${item.type === "IMAGE" ? "bg-blue-100 text-blue-700" : "bg-green-100 text-green-700"}`}>
                    {item.type}
                  </span>
                </div>
                <div className="text-gray-500">{item.tag || item.section}</div>
                <div className="flex justify-center">
                  <button ref={(el) => (btnRefs.current[item._id] = el)} onClick={() => handleToggle(item._id)} className="p-2 hover:bg-gray-200 rounded-full">
                    <FiMoreHorizontal size={18} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {openMenuId && (
          <div ref={menuRef} className="fixed w-36 bg-white border rounded-lg shadow-xl text-sm z-[9999] overflow-hidden" style={{ top: menuPosition.top, left: menuPosition.left }}>
            <button onClick={() => {
              const item = media.find(m => m._id === openMenuId);
              setEditData(item);
              item.type === "IMAGE" ? setGalleryModalOpen(true) : setVideoModalOpen(true);
              setOpenMenuId(null);
            }} className="flex items-center gap-2 w-full px-4 py-3 hover:bg-gray-100"><FiEdit className="text-orange-500" /> Edit</button>
            <button onClick={() => { setDeleteItem(media.find(m => m._id === openMenuId)); setOpenMenuId(null); }} className="flex items-center gap-2 w-full px-4 py-3 hover:bg-red-50 text-red-600 border-t"><FiTrash2 /> Delete</button>
          </div>
        )}

        {filteredData.length > 0 && (
          <div className="flex items-center justify-between bg-gray-50 px-6 py-4 border-t">
            <div className="text-sm text-gray-600">Page {currentPage} of {totalPages}</div>
            <div className="flex gap-2">
              <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} className="px-4 py-1.5 border rounded bg-white text-sm disabled:opacity-40">Previous</button>
              <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} className="px-4 py-1.5 border rounded bg-[#45A301] text-white text-sm">Next</button>
            </div>
          </div>
        )}
      </div>

      {deleteItem && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
          <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6">
            <h3 className="font-bold text-gray-800 text-lg">Delete Media</h3>
            <p className="text-sm text-gray-600 my-4">Are you sure you want to delete this {deleteItem.type.toLowerCase()}? This action is permanent.</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => setDeleteItem(null)} className="px-4 py-2 border rounded-md text-sm">Cancel</button>
              <button onClick={handleDelete} className="px-4 py-2 bg-red-600 text-white rounded-md text-sm">Delete</button>
            </div>
          </div>
        </div>
      )}

      {videoModalOpen && <VideoModal close={() => setVideoModalOpen(false)} editData={editData} refresh={fetchMedia} />}
      {galleryModalOpen && <GalleryModal close={() => setGalleryModalOpen(false)} editData={editData} refresh={fetchMedia} />}
    </div>
  );
};

export default GalleryManagement;